/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import VueI18n from 'vue-i18n'
import router from './routes/router';
import store from './store'
import VueCookie from 'vue-cookie'


import th from './languages/th'
import en from './languages/en'

import { VueReCaptcha } from 'vue-recaptcha-v3';
//Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA })
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA ,loaderOptions: {
    useRecaptchaNet: true,autoHideBadge: true
  }})



// Vue.prototype.getErrorText = function (data){
//   if (data.Msg == "errors.msw") {
//     return data.Cause;
//   }
//   return "";
// }
Vue.mixin({
  methods: {
    getErrorText: function(data) {
      if (data.Msg == "errors.msw") {
        return data.Cause;
      }
      return "";
    },
	TwoFAErrorText: function (msg,errkey) {
		let errorsCode = ["S-AUT-00000", "B-AUT-00001", "B-AUT-00002", "B-AUT-00402", "B-AUT-00403", "B-AUT-00404", "B-AUT-99999", "T-AUT-00101", "T-AUT-00102", "T-AUT-00103", "T-AUT-00405", "T-AUT-00503", "T-AUT-00901", "T-AUT-00902", "T-AUT-99999", "T-AUT-00101", "T-AUT-00102", "B-SRV-00403", "B-SRV-00404", "B-SRV-00406", "B-SRV-00410", "B-SRV-61001", "B-SRV-61002", "B-SRV-61003", "B-SRV-61004", "B-SRV-61005", "B-SRV-61006", "B-SRV-61007", "B-SRV-61009", "B-SRV-61010", "B-SRV-61011", "B-SRV-61012", "B-SRV-61013", "B-SRV-99999", "T-SRV-00101", "T-SRV-00102", "T-SRV-00103", "T-SRV-00405", "T-SRV-00503", "T-SRV-00901", "T-SRV-00902", "T-SRV-00904", "T-SRV-00905", "T-SRV-00906", "T-SRV-00907", "T-SRV-00908", "T-SRV-00909", "T-SRV-00910", "T-SRV-13001", "T-SRV-13003", "T-SRV-13004", "T-SRV-13005", "T-SRV-13006", "T-SRV-13002", "T-SRV-13000", "T-SRV-99999", "T-SRV-00101", "T-SRV-00102", "T-ESV-00401", "T-ESV-00498", "T-ESV-00502"]
		let errMsg = ""

		errorsCode.forEach(e=>{
			if (msg.includes(e)) {
				let key = "errors.twofa." + e.replaceAll("-","_")
				errMsg = this.$t(key)
				return
			}
		})

		return errMsg == "" ? this.$t(errkey) : errMsg
	},
	TwoFAErrorCode: function (msg) {
		let errorsCode = ["S-AUT-00000", "B-AUT-00001", "B-AUT-00002", "B-AUT-00402", "B-AUT-00403", "B-AUT-00404", "B-AUT-99999", "T-AUT-00101", "T-AUT-00102", "T-AUT-00103", "T-AUT-00405", "T-AUT-00503", "T-AUT-00901", "T-AUT-00902", "T-AUT-99999", "T-AUT-00101", "T-AUT-00102", "B-SRV-00403", "B-SRV-00404", "B-SRV-00406", "B-SRV-00410", "B-SRV-61001", "B-SRV-61002", "B-SRV-61003", "B-SRV-61004", "B-SRV-61005", "B-SRV-61006", "B-SRV-61007", "B-SRV-61009", "B-SRV-61010", "B-SRV-61011", "B-SRV-61012", "B-SRV-61013", "B-SRV-99999", "T-SRV-00101", "T-SRV-00102", "T-SRV-00103", "T-SRV-00405", "T-SRV-00503", "T-SRV-00901", "T-SRV-00902", "T-SRV-00904", "T-SRV-00905", "T-SRV-00906", "T-SRV-00907", "T-SRV-00908", "T-SRV-00909", "T-SRV-00910", "T-SRV-13001", "T-SRV-13003", "T-SRV-13004", "T-SRV-13005", "T-SRV-13006", "T-SRV-13002", "T-SRV-13000", "T-SRV-99999", "T-SRV-00101", "T-SRV-00102", "T-ESV-00401", "T-ESV-00498", "T-ESV-00502"]
		let errMsg = ""

		errorsCode.forEach(e=>{
			if (msg.includes(e)) {
				let key = "errors.twofa_code"
				errMsg = this.$t(key,[e])
				return
			}
		})
		return errMsg
	}
  }
});

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueCookie )

/*
const messages = {
  en: {
    errors : {

      db_query_failed : "เชื่อมต่อฐานข้อมูลผิดพลาด",
      db_fetch_failed : "การอ่านข้อมูลจากฐานข้อมูลผิดพลาด",
      permission_denied : "คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้",
      msw : "การเชื่อมต่อ MSw API ล้มเหลว",
      msw_unknown_result: "ไม่สามารถอ่านข้อมูลจาก MSw API",
      invalid_param: "ข้อมูลที่ระบุไม่ถูกต้อง",
      dtac : {
        idcard_validate_fail:"หมายเลขนี้ไม่มีสิทธิ์ในการใช้งาน",
        subs_status_failed:"สถานะหมายเลขนี้ไม่ถูกต้อง",
        package_failed:"ไม่มีแพ็คเกจที่สามารถใช้งานได้",
        wci_failed:"การเชื่อมต่อ DTAC API ล้มเหลว",
        unknown_result:"ไม่สามารถอ่านข้อมูลจาก DTAC API",
      },
      user : {
          duplicate : "ข้อมูลผู้งานซ้ำ",
          duplicate_username : "ข้อมูลผู้ใช้งานซ้ำ",
          duplicate_email : "ข้อมูลอีเมล์ซ้ำ",
          blcok_delete_by_self : "ไม่สามารถลบข้อมูลตนเองได้",
          fail: "การปรับปรุงข้อมูลผู้งานผิดพลาด",
      },
      corp : {
          duplicate : "ข้อมูลองค์กรซ้ำ",
          not_exist : "ไม่พบข้อมูลองค์กร",
          check_number_fail: "การตรวจสอบหมายเลขผิดพลาด",
          fail: "การปรับปรุงข้อมูลองค์กรผิดพลาด",
      },
      mlhg : {
          duplicate: "ข้อมูลกลุ่ม Hunt ซ้ำ",
          get_dummy_number_fail: "ไม่พบข้อมูลหมายเลขนำหมู่",
          not_exist : "ไม่พบข้อมูลกลุ่ม Hunt",
          member_not_exist : "ไม่พบข้อมูลหมายเลขในกลุ่ม Hunt",
          get_enterprise_fail: "ไม่พบข้อมูลองค์กร",
          get_mlhg_fail: "ไม่พบข้อมูลกลุ่ม Hung",
          get_pilot_fail: "ไม่พบข้อมูลหมายเลขนำหมู่",
          redeem_dummy_pilot_failed: "ไม่สามารถคืนหมาย",
          number_duplicate: "มีหมายเลขนี้แล้วในกลุ่ม Hunt",
      },
      auth : {
          login_fail : "เข้าสู่ระบบผิดลาด",
          login_success : "เข้าสู่ระบบสำเร็จ",
          logout_success : "ออกจากระบบไม่สำเร็จ",
          unauthoriezed : "เข้าสู่ระบบผิดพลาด",
          reset_invalid_token: "token ไม่ถูกต้อง",
          reset_token_expired: "token หมดอายุ",
          reset_password_fail : "เปลี่ยนรหัสผ่านไม่สำเร็จ",
      },
      package : {
          duplicate_code : "รหัสแพ็คเกจซ้ำ",
          duplicate_name : "ชื่อแพ็คเกจซ้ำ" ,
          not_exist: "ไม่พบข้อมูลแพ็คเกจ",
          delete_lock: "ไม่สามารถลบข้อมูลแพ็คเกจได้ เนื่องจากมีการใช้งาน",
          get_profile_failed: "ไม่สามารถอ่านข้อมูลแพ็คเกจโปรไฟล์ได้",
      },
      subs : {
          not_exist : "ไม่พบหมายเลขนี้",
          corp_not_match : "ข้อมูลองค์กรไม่ถูกต้อง",
          get_crop_id_failed: "ไม่พบข้อมูลองค์กรหรือหมายเลของค์กร",
          comp_login_failed: "ไม่สามารถเข้าสู่ระบบ ComPortal ได้",
          duplicate: "หมายเลขซ้ำ",
          get_charge_number_failed: "ไม่สามารถอ่านข้อมูลหมายเลขคิดค่าใช้จ่าย",
          set_charge_number_failed: "ไม่สามารถแก้ไขข้อมูลหมายเลขคิดค่าใช้จ่าย",
          get_brn_failed: "ไม่พบข้อมูลหมายเลข BRN",
          is_mlhg_member: "หมายเลขนี้เป็นสมาชิกของกลุ่ม Hunt",
          number_range_delete_fail: "ไม่สามารถลบข้อมูลช่วงหมายเลข",
          comp_login_failed: "เข้าสู่ระบบ ComPortal ผิดพลาด",
      }
    },

  
    bc_portal : "Web Portal",
    bc_package : "Package",
    bc_voicemail : "Voice Mail",
    bc_report : "Record Detail",
    bc_user : "User",
    bc_corporate : "Corporate",
    bc_mlhg : "Hunt Group",
    bc_pilot_number : "Enterprise Number",
    bc_agent_number : "User Number",

    menu: {
      corporate: 'Corporate',
      mlhg: 'Hung Group',
      package: 'Package',
      pilot_number: 'Enterprise Number',
      agent_number: 'User Number',
      number: 'Number',
      user: 'User',
      voicemail: 'Voice Mail',
      cdr: 'Record Detail',
      nseries: 'Voice Conference'
    },
    error:{
      auth_loginfail : 'Login fail',
      auth_forget_password_fail : 'forget password fail',
      auth_reset_password_fail : 'reset password fail',
      db : 'database error.',
      prov_msw : "Can't provision",
      prov_esb : "Can't check number infomation",
    },

    auth: {

    },


    corp : {

    },

    package: {

    },
    pilotNumber : {

    },
    agentNumber : {

    },
    voiceMain: {

    },
    report: {

    },


    auth_signin : 'SignIn',
    auth_signout : 'Logout',
    auth_username: "E-Mail",
    auth_password: "Password",
    auth_forgetpassword: "Forget Password",
    corp_name : "Corporate",
    corp_brn : "BRN",
    corp_code : "Code",
    corp_create : "Create Corporate",
    package_name : 'Package',
    package_code : 'Package Code',
    package_create : 'Create Package',
    package_profile : 'Persistent Profile',
    package_cos : 'Class Of Service',
    number_pilot : 'Enterprise Number',
    number_agent : 'User Number',
    number_charge : 'Charge Number',
    user_create : 'Create User',
    user_username : 'Username',
    user_name : 'Name',
    user_type : 'Type',
    user_phone : 'Phone',
    user_role : 'Role',
    voice_name : 'Voice Mail',
    voice_to : 'to',
    voice_from : 'from',
    voice_date : 'date',
    voice_corp : 'Corporate',
    report_menu : 'Record Detail',
    report_type : 'Record Type',
    report_start : 'Start',
    report_end : 'End',
    report_duration : 'Duration',
    report_corp : 'Corporate',
    mlhg_name : 'HUNT Group',
    mlhg_number : 'Number',
    mlhg_number : 'Number',

    group_name : 'Group Name',
    checkbrn : "Check BRN",
    corporate : "Corporate",
    email : "E-Mail",
    email_optional : "E-Mail (Optional)",
    created : "Created",
    search: "Search",
    save: "Save",
    back: "Back",
    new: "New",
    number: "Number",
    mlhg: "Hung Group",
    status: "Status",
    syncpackage: "Sync Package for all",
    download: "Download",
    downloadall: "Download All",
    search: "Search",
    welcome: "Welcome",
    myprofile: "Profile",
    changepassword: "Change Password",
    page_notfound : "Sorry Page not found.",
    page_notfound_desc : "Plase check URL again.",
    actions : "Menu",
    create : "Create",
    number_create_success : "Create Number Success",


    data: "Data ",
    to : "To",
    of : "Of",
    row_select : "rows selected",

    yes: "Yes",
    no: "No",
    ok: "Ok",
    cancel: "Cancel",
    upload_file: "Upload File",
    number_add: "Add Number",

    bg_admin : "Setting",
    add: "Add",
    close: "Close",
    please_select : "Please select..",
    create_success : "Create Success",




  },

  th: {
    errors : {

      db_query_failed : "เชื่อมต่อฐานข้อมูลผิดพลาด",
      db_fetch_failed : "การอ่านข้อมูลจากฐานข้อมูลผิดพลาด",
      permission_denied : "คุณไม่มีสิทธิ์เข้าใช้งานระบบนี้",
      msw : "การเชื่อมต่อ MSw API ล้มเหลว",
      msw_unknown_result: "ไม่สามารถอ่านข้อมูลจาก MSw API",
      invalid_param: "ข้อมูลที่ระบุไม่ถูกต้อง",
      dtac : {
        idcard_validate_fail:"หมายเลขนี้ไม่มีสิทธิ์ในการใช้งาน",
        subs_status_failed:"สถานะหมายเลขนี้ไม่ถูกต้อง",
        package_failed:"ไม่มีแพ็คเกจที่สามารถใช้งานได้",
        wci_failed:"การเชื่อมต่อ DTAC API ล้มเหลว",
        unknown_result:"ไม่สามารถอ่านข้อมูลจาก DTAC API",
      },
      user : {
          duplicate : "ข้อมูลผู้งานซ้ำ",
          duplicate_username : "ข้อมูลผู้ใช้งานซ้ำ",
          duplicate_email : "ข้อมูลอีเมล์ซ้ำ",
          blcok_delete_by_self : "ไม่สามารถลบข้อมูลตนเองได้",
          fail: "การปรับปรุงข้อมูลผู้งานผิดพลาด",
      },
      corp : {
          duplicate : "ข้อมูลองค์กรซ้ำ",
          not_exist : "ไม่พบข้อมูลองค์กร",
          check_number_fail: "การตรวจสอบหมายเลขผิดพลาด",
          fail: "การปรับปรุงข้อมูลองค์กรผิดพลาด",
      },
      mlhg : {
          duplicate: "ข้อมูลกลุ่ม Hunt ซ้ำ",
          get_dummy_number_fail: "ไม่พบข้อมูลหมายเลขนำหมู่",
          not_exist : "ไม่พบข้อมูลกลุ่ม Hunt",
          member_not_exist : "ไม่พบข้อมูลหมายเลขในกลุ่ม Hunt",
          get_enterprise_fail: "ไม่พบข้อมูลองค์กร",
          get_mlhg_fail: "ไม่พบข้อมูลกลุ่ม Hung",
          get_pilot_fail: "ไม่พบข้อมูลหมายเลขนำหมู่",
          redeem_dummy_pilot_failed: "ไม่สามารถคืนหมาย",
          number_duplicate: "มีหมายเลขนี้แล้วในกลุ่ม Hunt",
      },
      auth : {
          login_fail : "เข้าสู่ระบบผิดลาด",
          login_success : "เข้าสู่ระบบสำเร็จ",
          logout_success : "ออกจากระบบไม่สำเร็จ",
          unauthoriezed : "เข้าสู่ระบบผิดพลาด",
          reset_invalid_token: "token ไม่ถูกต้อง",
          reset_token_expired: "token หมดอายุ",
          reset_password_fail : "เปลี่ยนรหัสผ่านไม่สำเร็จ",
      },
      package : {
          duplicate_code : "รหัสแพ็คเกจซ้ำ",
          duplicate_name : "ชื่อแพ็คเกจซ้ำ" ,
          not_exist: "ไม่พบข้อมูลแพ็คเกจ",
          delete_lock: "ไม่สามารถลบข้อมูลแพ็คเกจได้ เนื่องจากมีการใช้งาน",
          get_profile_failed: "ไม่สามารถอ่านข้อมูลแพ็คเกจโปรไฟล์ได้",
      },
      subs : {
          not_exist : "ไม่พบหมายเลขนี้",
          corp_not_match : "ข้อมูลองค์กรไม่ถูกต้อง",
          get_crop_id_failed: "ไม่พบข้อมูลองค์กรหรือหมายเลของค์กร",
          comp_login_failed: "ไม่สามารถเข้าสู่ระบบ ComPortal ได้",
          duplicate: "หมายเลขซ้ำ",
          get_charge_number_failed: "ไม่สามารถอ่านข้อมูลหมายเลขคิดค่าใช้จ่าย",
          set_charge_number_failed: "ไม่สามารถแก้ไขข้อมูลหมายเลขคิดค่าใช้จ่าย",
          get_brn_failed: "ไม่พบข้อมูลหมายเลข BRN",
          is_mlhg_member: "หมายเลขนี้เป็นสมาชิกของกลุ่ม Hunt",
          number_range_delete_fail: "ไม่สามารถลบข้อมูลช่วงหมายเลข",
          comp_login_failed: "เข้าสู่ระบบ ComPortal ผิดพลาด",
      }
    },
    // Bread Crumb
    bc_portal : "Web Portal",
    bc_package : "แพ็คเกจ",
    bc_voicemail : "ข้อความเสียง",
    bc_report : "ข้อมูลการโทร",
    bc_user : "ผู้ใช้งาน",
    bc_corporate : "องค์กร",
    bc_mlhg : "กลุ่ม Hunt",
    bc_pilot_number : "หมายเลของค์กร",
    bc_agent_number : "หมายเลขผู้ใช้งาน",
    

    menu: {
      corporate: 'องค์กร',
      mlhg: 'กลุ่ม Hunt',
      package: 'แพ็คเกจ',
      pilot_number: 'หมายเลของค์กร',
      agent_number: 'หมายเลขผู้ใช้งาน',
      number: 'หมายเลข',
      user: 'ผู้ใช้งาน',
      voicemail: 'ข้อความเสียง',
      cdr: 'ข้อมูลการโทร',
      nseries: 'การประชุมผ่านโทรศัพท์',
    },
    error:{
      auth_loginfail : 'ไม่สามารถเข้าสู่ระบบได้',
      auth_forget_password_fail : 'ไม่สามารถขอรหัสผ่านใหม่ได้',
      auth_reset_password_fail : 'ไม่สามารถเปลี่ยนรหัสผ่านใหม่ได้',
      db : 'การทำงานของฐานข้อมูลผิดพลาด',
      prov_msw : 'ไม่สามารถเชื่อมต่อระบบได้',
      prov_esb : 'ไม่สามารถตรวจสอบข้อมูลหมายเลขโทรศัพท์',
    },

    auth: {

    },


    corp : {

    },

    package: {

    },
    pilotNumber : {

    },
    agentNumber : {
      chargeNumber : "หมายเลขที่คิดเงิน"
    },
    voiceMain: {

    },
    report: {

    },

    
    auth_signin : 'เข้าสู่ระบบ',
    auth_signout : 'ออกจากระบบ',
    auth_username: "อีเมล์",
    auth_password: "รหัสผ่าน",
    auth_forgetpassword: "ลืมรหัสผ่าน",
    corp_name : "ชื่อองค์กร",
    corp_brn : "BRN",
    corp_code : "หมายเลของค์กร",
    corp_create : "สร้างองค์กร",
    package_name : 'ชื่อแพ็คเกจ',
    package_code : 'หมายเลขแพ็คเกจ',
    package_create : 'สร้างแพ็คเกจ',
    package_actions : 'เมนู',
    package_profile : 'Persistent Profile',
    package_cos : 'Class Of Service',
    number_pilot : 'หมายเลของค์กร',
    number_agent : 'หมายเลขผู้ใช้งาน',
    number_charge : 'หมายเลขที่คิดค่าใช้จ่าย',
    user_create : 'สร้างผู้ใช้งาน',
    user_name : 'ชื่อ',
    user_username : 'ชื่อผู้ใช้',
    user_type : 'ประเภท',
    user_phone : 'เบอร์โทรศัพท์',
    user_role : 'ระดับผู้ใช้งาน',
    voice_name : 'ข้อความเสียง',
    voice_to : 'ถึง',
    voice_from : 'จาก',
    voice_date : 'วันที่',
    voice_corp : 'องค์กร',
    report_menu : 'ข้อมูลการโทร',
    report_type : 'ประเภทการโทร',
    report_start : 'เริ่มต้น',
    report_end : 'ส้ินสุด',
    report_duration : 'เวลาใช้งาน',
    report_corp : 'องค์กร',
    mlhg_name : 'กลุ่ม Hunt',
    mlhg_number : 'หมายเลข',
    group_name : 'ชื่อกลุ่ม',

    checkbrn : "ตรวจสอบ BRN",
    corporate : "องค์กร",
    email : "อีเมล์",
    email_optional : "อีเมล์ (ไม่ระบุ)",
    created : "วันที่สร้าง",
    search: "ค้นหา",
    save: "บันทึก",
    back: "กลับ",
    new: "สร้าง",
    number: "หมายเลข",
    status: "สถานะ",
    syncpackage: "Sync Package for all",
    download: "ดาวน์โหลด",
    downloadall: "ดาวน์โหลดทั้งหมด",
    search: "ค้นหา",
    welcome: "ยินดีต้อนรับ",
    myprofile: "ข้อมูลส่วนตัว",
    changepassword: "เปลี่ยนรหัสผ่าน",
    page_notfound : "ขออภัย ไม่พบหน้าที่คุณต้องการ",
    page_notfound_desc : "หน้าดังกล่าวอาจมีการเปลี่ยนแปลง ชื่อ หรือ URL ไม่ถูกต้อง กรุณาตรวจสอบลิงค์ที่คุณเข้ามาอีกครั้ง",
    actions : "เมนู",
    number_create_success : "สร้างหมายเลขสำเร็จ",

    create_success : "สร้างข้อมูลสำเร็จ",

    data: "ข้อมูล",
    to : "ถึง",
    of : "จาก",
    row_select : "ข้อมูลที่ถูกเลือก",


    yes: "ใช่",
    no: "ไม่ใช่",
    ok: "ตกลง",
    cancel: "ยกเลิก",
    upload_file: "เพิ่มไฟล์",
    number_add: "เพิ่มหมายเลข",
    create: "สร้าง",

    // Menu
    confirm_delete : "ยืนยันการลบข้อมูล",
    confirm_delete_text : "คุณต้องการลบข้อมูล ",
    bg_admin : "ตั้งค่า",
    add: "เพิ่ม",
    close: "ปิด",
    please_select : "กรุณาเลือก",



    // wait tranlate
    corporate_code: "รหัสองค์กร",
    corporate_brn: "หมายเลข BRN",
    delete_confirm: "ยืนยันการลบข้อมูล",
    confirm: "ยืนยัน",
    delete_confirm_question: "คุณต้องการลบข้อมูล ",
    delete_success: "ลบข้อมูลสำเร็จ",
    delete_fail: "ลบข้อมูลไม่สำเร็จ",
    edit_success: "แก้ไขข้อมูลสำเร็จ",
    edit_fail: "แก้ไขข้อมูลไม่สำเร็จ",

    corporate_create_success: "สร้างองค์กรสำเร็จ",
    corporate_create_fail: "สร้างองค์กรไม่สำเร็จ",
    package_create_success: "สร้างแพ็คเกจสำเร็จ",
    package_create_fail: "สร้างแพ็คเกจไม่สำเร็จ",

    pilot_create_success: "สร้างเบอร์องค์กรสำเร็จ",
    pilot_create_fail: "สร้างเบอร์องค์กรไม่สำเร็จ",
    agent_create_success: "สร้างเบอร์ผู้ใช้งานสำเร็จ",
    agent_create_fail: "สร้างเบอร์ผู้ใช้งานไม่สำเร็จ",
    user_create_success: "สร้างผู้ใช้งานสำเร็จ",
    user_create_fail: "สร้างผู้ใช้งานไม่สำเร็จ",
    package : "แพ็คเกจ",
    bgadmin_fail : "ไม่สามารถเข้าสู่ระบบการตั้งค่าได้",
    number_agent_create : 'สร้างหมายเลขผู้ใช้งาน',
    number_pilot_create : 'สร้างหมายเลของค์กร',
    mlhg_pilot_number : 'หมายเลขนำหมู่',




    mlhg : {
      name : 'กลุ่ม Hunt',
      failed : "กลุ่ม Hunt ล้มเหลว",
      success : "กลุ่ม Hunt สำเร็จ",
    },
    user : {
      type : 'ประเภทผู้ใช้งาน'
    }
    
  }
}
*/


Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'th', // set locale
  messages : { en:en , th:th}, // set locale messages
})


/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  render: h => h(App),
  store,
  router
});

